import { SETTINGS_IMPORT_SECTION_DATA } from '@webapp/containers/SettingsImport/constants'
import { useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import { LegacyImporter } from '@webapp/platform/_unmigrated/Importer'
import messages from './messages'

export interface BudgetCategoryImporterProps {
  handleModalClose: () => void
}

export const BudgetCategoryImporter = ({
  handleModalClose,
}: BudgetCategoryImporterProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  return (
    <LegacyImporter
      title={intl.formatMessage(
        FT_5817_ENABLE_BUDGETS_REDESIGN
          ? messages.importerTitle
          : messages.oldImporterTitle
      )}
      type={SETTINGS_IMPORT_SECTION_DATA.BUDGET_CATEGORY.type}
      onDismiss={handleModalClose}
      {...SETTINGS_IMPORT_SECTION_DATA.BUDGET_CATEGORY.importerOptions}
    />
  )
}
